import styled, { css } from 'styled-components'
import Icon from '../../Icon'

export const FormInputLabelWrapperStyled = styled.label``

export const FormInputLabelStyled = styled.div`
  color: ${({ theme }) => theme.greyishBrown};
  margin-bottom: 10px;
`

export const FormInputStyled = styled.input`
  display: block;
  padding: 15px;
  border: 2px solid ${({ theme }) => theme.veryLightPinkTwo};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.greyishBrown};
  border-radius: 6px;
  transition: border .15s;
  width: 100%;
  background-color: ${({ theme }) => theme.veryLightPinkTwo};
  ::placeholder {
    text-align: center;
    color: ${({ theme }) => theme.brownGrey};
    transition: all 0.15s;
  }
  ${({ focused }) =>
    focused &&
    css`
      ::placeholder {
        text-align: left;
        color: ${({ theme }) => theme.lightPeach};
      }
      background-color: ${({ theme }) => theme.whiteTwo};
      border: 2px solid rgba(48, 154, 2, 0.5);
    `

  }
  ${({ marginVertical }) =>
    marginVertical &&
    css`
        margin-top: 10px;
        margin-bottom: 10px;
    `
  }
  ${({ icon }) =>
    icon &&
    css`
        padding-left: 55px;
    `
  }
`

export const StyledIcon = styled(Icon).attrs(({ theme, focused }) => ({
  color: focused ? theme.grassyGreen : theme.brownGrey
}))`
  position: absolute;
  left: 14px;
  bottom: 24px;
  transition: color 0.15s;
`

export const FormInputError = styled.div`
  color: ${({ theme }) => theme.pastelRed};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: 5px;
  margin-bottom: 5px;
  height: 15px;
  opacity: 0;
  transition: opacity .15s;
`

export const FormInputWrapper = styled.div`
  position: relative;
  ${({ error }) =>
    error &&
    css`
      ${FormInputStyled} {
        border: 2px solid ${({ theme }) => theme.pastelRed};
      }
      ${FormInputError} {
        opacity: 1;
      }
    `
  }
   ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `
  }
`